import { FC, useMemo } from 'react';

import clsx from 'clsx';

import { Flex } from '../Flex';
import styles from './styles.module.css';
import Typography from '../Typography';

interface SegmentedControl {
  value: string | number;
  disabled?: boolean;
  onChange?: (value: string | number) => void;
  values: { id: string | number; label: string }[];
  shape?: 'square' | 'rounded';
  size?: 'small' | 'large';
  renderTab?: (value: string | number, active: boolean) => React.ReactNode;
}
export const SegmentedControl: FC<SegmentedControl> = ({
  value,
  disabled,
  onChange,
  values,
  shape = 'square',
  size = 'large',
  renderTab
}) => {
  const offset = useMemo(() => {
    const index = values.findIndex(v => v.id === value);

    return (100 / values.length) * index;
  }, [values, value]);

  const changeHandle = (id: string | number) => {
    if (disabled) return;
    onChange?.(id);
  };

  return (
    <Flex
      className={clsx(
        styles.tabs,
        disabled && styles._disabled,
        shape === 'rounded' && styles._rounded,
        size === 'small' && styles._small
      )}
    >
      {values.map(({ id, label }) => (
        <div
          style={{ flexBasis: `${100 / values.length}%` }}
          // variant="bare"
          className={clsx(
            styles.tab,
            value === id && styles.active,
            shape === 'rounded' && styles._rounded
          )}
          onClick={() => changeHandle(id)}
        >
          {renderTab ? (
            renderTab(label, value === id)
          ) : (
            <Typography
              color={
                value === id
                  ? 'var(--color-interaction-inverted-subtle-selected)'
                  : 'var(--color-interaction-inverted-normal)'
              }
              style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {label}
            </Typography>
          )}
        </div>
      ))}

      <span
        style={{
          width: `calc(${100 / values.length}% - 8px)`,
          left: `calc(${offset}% + 4px)`
        }}
        className={clsx(styles.tabIndicator, shape === 'rounded' && styles._rounded)}
      />
    </Flex>
  );
};

export default SegmentedControl;
